/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ProfielRouteRouteImport } from './routes/profiel/route'
import { Route as OrganisatieProfielRouteRouteImport } from './routes/organisatie-profiel/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as OrganisatieProfielIndexRouteImport } from './routes/organisatie-profiel/index'
import { Route as LoginIndexRouteImport } from './routes/login/index'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as CorrespondentieIndexRouteImport } from './routes/correspondentie/index'
import { Route as BeheerIndexRouteImport } from './routes/beheer/index'
import { Route as LoginMicrosoft_ssoRouteImport } from './routes/login/microsoft_sso'
import { Route as LoginGoogle_ssoRouteImport } from './routes/login/google_sso'
import { Route as LoginTokenRouteImport } from './routes/login/$token'
import { Route as CorrespondentieThreadIdRouteImport } from './routes/correspondentie/$threadId'
import { Route as ProfielGekoppeldeCursistenIndexRouteImport } from './routes/profiel/gekoppelde-cursisten/index'
import { Route as ProfielGegevensIndexRouteImport } from './routes/profiel/gegevens/index'
import { Route as OrganisatieProfielMedewerkersIndexRouteImport } from './routes/organisatie-profiel/medewerkers/index'
import { Route as OrganisatieProfielGegevensIndexRouteImport } from './routes/organisatie-profiel/gegevens/index'
import { Route as BeheerMedewerkersIndexRouteImport } from './routes/beheer/medewerkers/index'
import { Route as BeheerGroepenIndexRouteImport } from './routes/beheer/groepen/index'
import { Route as BeheerGebruikersIndexRouteImport } from './routes/beheer/gebruikers/index'
import { Route as BeheerCursistenIndexRouteImport } from './routes/beheer/cursisten/index'
import { Route as BeheerContractenIndexRouteImport } from './routes/beheer/contracten/index'
import { Route as BeheerAanmeldingenIndexRouteImport } from './routes/beheer/aanmeldingen/index'
import { Route as AuthSso_callbackIndexRouteImport } from './routes/auth/sso_callback/index'
import { Route as AuthFailed_ssoIndexRouteImport } from './routes/auth/failed_sso/index'
import { Route as OrganisatieProfielMedewerkersAanmakenRouteImport } from './routes/organisatie-profiel/medewerkers/aanmaken'
import { Route as BeheerMedewerkersAanmakenRouteImport } from './routes/beheer/medewerkers/aanmaken'
import { Route as BeheerCursistenAanmakenRouteImport } from './routes/beheer/cursisten/aanmaken'
import { Route as BeheerMedewerkersOrganizationUserIdRouteRouteImport } from './routes/beheer/medewerkers/$organizationUserId/route'
import { Route as BeheerGroepenGroupIdRouteRouteImport } from './routes/beheer/groepen/$groupId/route'
import { Route as BeheerCursistenStudentIdRouteRouteImport } from './routes/beheer/cursisten/$studentId/route'
import { Route as BeheerContractenContractIdRouteRouteImport } from './routes/beheer/contracten/$contractId/route'
import { Route as BeheerContractenContractIdIndexRouteImport } from './routes/beheer/contracten/$contractId/index'
import { Route as BeheerAanmeldingenStudentRegistrationIdOpnieuwIndienenRouteImport } from './routes/beheer/aanmeldingen/$studentRegistrationId/opnieuw-indienen'
import { Route as BeheerMedewerkersOrganizationUserIdGekoppeldeCursistenIndexRouteImport } from './routes/beheer/medewerkers/$organizationUserId/gekoppelde-cursisten/index'
import { Route as BeheerMedewerkersOrganizationUserIdGegevensIndexRouteImport } from './routes/beheer/medewerkers/$organizationUserId/gegevens/index'
import { Route as BeheerGroepenGroupIdStudentsIndexRouteImport } from './routes/beheer/groepen/$groupId/students/index'
import { Route as BeheerGroepenGroupIdLessenIndexRouteImport } from './routes/beheer/groepen/$groupId/lessen/index'
import { Route as BeheerGroepenGroupIdCorrespondentieIndexRouteImport } from './routes/beheer/groepen/$groupId/correspondentie/index'
import { Route as BeheerCursistenStudentIdVoortgangIndexRouteImport } from './routes/beheer/cursisten/$studentId/voortgang/index'
import { Route as BeheerCursistenStudentIdTweedeAanspreekpuntIndexRouteImport } from './routes/beheer/cursisten/$studentId/tweede-aanspreekpunt/index'
import { Route as BeheerCursistenStudentIdRapportagesIndexRouteImport } from './routes/beheer/cursisten/$studentId/rapportages/index'
import { Route as BeheerCursistenStudentIdLessenIndexRouteImport } from './routes/beheer/cursisten/$studentId/lessen/index'
import { Route as BeheerCursistenStudentIdIntakeIndexRouteImport } from './routes/beheer/cursisten/$studentId/intake/index'
import { Route as BeheerCursistenStudentIdGegevensIndexRouteImport } from './routes/beheer/cursisten/$studentId/gegevens/index'
import { Route as BeheerCursistenStudentIdCorrespondentieIndexRouteImport } from './routes/beheer/cursisten/$studentId/correspondentie/index'
import { Route as BeheerContractenContractIdCorrespondentieIndexRouteImport } from './routes/beheer/contracten/$contractId/correspondentie/index'
import { Route as BeheerGroepenGroupIdCorrespondentieThreadIdRouteImport } from './routes/beheer/groepen/$groupId/correspondentie/$threadId'
import { Route as BeheerCursistenStudentIdCorrespondentieThreadIdRouteImport } from './routes/beheer/cursisten/$studentId/correspondentie/$threadId'
import { Route as BeheerContractenContractIdOrganisatiesOrganizationRouteImport } from './routes/beheer/contracten/$contractId/organisaties/$organization'
import { Route as BeheerContractenContractIdCorrespondentieThreadIdRouteImport } from './routes/beheer/contracten/$contractId/correspondentie/$threadId'

const ProfielRouteRoute = ProfielRouteRouteImport.update({
  id: '/profiel',
  path: '/profiel',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganisatieProfielRouteRoute = OrganisatieProfielRouteRouteImport.update({
  id: '/organisatie-profiel',
  path: '/organisatie-profiel',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganisatieProfielIndexRoute = OrganisatieProfielIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OrganisatieProfielRouteRoute,
} as any)
const LoginIndexRoute = LoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => rootRouteImport,
} as any)
const CorrespondentieIndexRoute = CorrespondentieIndexRouteImport.update({
  id: '/correspondentie/',
  path: '/correspondentie/',
  getParentRoute: () => rootRouteImport,
} as any)
const BeheerIndexRoute = BeheerIndexRouteImport.update({
  id: '/beheer/',
  path: '/beheer/',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginMicrosoft_ssoRoute = LoginMicrosoft_ssoRouteImport.update({
  id: '/login/microsoft_sso',
  path: '/login/microsoft_sso',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginGoogle_ssoRoute = LoginGoogle_ssoRouteImport.update({
  id: '/login/google_sso',
  path: '/login/google_sso',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginTokenRoute = LoginTokenRouteImport.update({
  id: '/login/$token',
  path: '/login/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const CorrespondentieThreadIdRoute = CorrespondentieThreadIdRouteImport.update({
  id: '/correspondentie/$threadId',
  path: '/correspondentie/$threadId',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfielGekoppeldeCursistenIndexRoute =
  ProfielGekoppeldeCursistenIndexRouteImport.update({
    id: '/gekoppelde-cursisten/',
    path: '/gekoppelde-cursisten/',
    getParentRoute: () => ProfielRouteRoute,
  } as any)
const ProfielGegevensIndexRoute = ProfielGegevensIndexRouteImport.update({
  id: '/gegevens/',
  path: '/gegevens/',
  getParentRoute: () => ProfielRouteRoute,
} as any)
const OrganisatieProfielMedewerkersIndexRoute =
  OrganisatieProfielMedewerkersIndexRouteImport.update({
    id: '/medewerkers/',
    path: '/medewerkers/',
    getParentRoute: () => OrganisatieProfielRouteRoute,
  } as any)
const OrganisatieProfielGegevensIndexRoute =
  OrganisatieProfielGegevensIndexRouteImport.update({
    id: '/gegevens/',
    path: '/gegevens/',
    getParentRoute: () => OrganisatieProfielRouteRoute,
  } as any)
const BeheerMedewerkersIndexRoute = BeheerMedewerkersIndexRouteImport.update({
  id: '/beheer/medewerkers/',
  path: '/beheer/medewerkers/',
  getParentRoute: () => rootRouteImport,
} as any)
const BeheerGroepenIndexRoute = BeheerGroepenIndexRouteImport.update({
  id: '/beheer/groepen/',
  path: '/beheer/groepen/',
  getParentRoute: () => rootRouteImport,
} as any)
const BeheerGebruikersIndexRoute = BeheerGebruikersIndexRouteImport.update({
  id: '/beheer/gebruikers/',
  path: '/beheer/gebruikers/',
  getParentRoute: () => rootRouteImport,
} as any)
const BeheerCursistenIndexRoute = BeheerCursistenIndexRouteImport.update({
  id: '/beheer/cursisten/',
  path: '/beheer/cursisten/',
  getParentRoute: () => rootRouteImport,
} as any)
const BeheerContractenIndexRoute = BeheerContractenIndexRouteImport.update({
  id: '/beheer/contracten/',
  path: '/beheer/contracten/',
  getParentRoute: () => rootRouteImport,
} as any)
const BeheerAanmeldingenIndexRoute = BeheerAanmeldingenIndexRouteImport.update({
  id: '/beheer/aanmeldingen/',
  path: '/beheer/aanmeldingen/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSso_callbackIndexRoute = AuthSso_callbackIndexRouteImport.update({
  id: '/auth/sso_callback/',
  path: '/auth/sso_callback/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthFailed_ssoIndexRoute = AuthFailed_ssoIndexRouteImport.update({
  id: '/auth/failed_sso/',
  path: '/auth/failed_sso/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganisatieProfielMedewerkersAanmakenRoute =
  OrganisatieProfielMedewerkersAanmakenRouteImport.update({
    id: '/medewerkers/aanmaken',
    path: '/medewerkers/aanmaken',
    getParentRoute: () => OrganisatieProfielRouteRoute,
  } as any)
const BeheerMedewerkersAanmakenRoute =
  BeheerMedewerkersAanmakenRouteImport.update({
    id: '/beheer/medewerkers/aanmaken',
    path: '/beheer/medewerkers/aanmaken',
    getParentRoute: () => rootRouteImport,
  } as any)
const BeheerCursistenAanmakenRoute = BeheerCursistenAanmakenRouteImport.update({
  id: '/beheer/cursisten/aanmaken',
  path: '/beheer/cursisten/aanmaken',
  getParentRoute: () => rootRouteImport,
} as any)
const BeheerMedewerkersOrganizationUserIdRouteRoute =
  BeheerMedewerkersOrganizationUserIdRouteRouteImport.update({
    id: '/beheer/medewerkers/$organizationUserId',
    path: '/beheer/medewerkers/$organizationUserId',
    getParentRoute: () => rootRouteImport,
  } as any)
const BeheerGroepenGroupIdRouteRoute =
  BeheerGroepenGroupIdRouteRouteImport.update({
    id: '/beheer/groepen/$groupId',
    path: '/beheer/groepen/$groupId',
    getParentRoute: () => rootRouteImport,
  } as any)
const BeheerCursistenStudentIdRouteRoute =
  BeheerCursistenStudentIdRouteRouteImport.update({
    id: '/beheer/cursisten/$studentId',
    path: '/beheer/cursisten/$studentId',
    getParentRoute: () => rootRouteImport,
  } as any)
const BeheerContractenContractIdRouteRoute =
  BeheerContractenContractIdRouteRouteImport.update({
    id: '/beheer/contracten/$contractId',
    path: '/beheer/contracten/$contractId',
    getParentRoute: () => rootRouteImport,
  } as any)
const BeheerContractenContractIdIndexRoute =
  BeheerContractenContractIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BeheerContractenContractIdRouteRoute,
  } as any)
const BeheerAanmeldingenStudentRegistrationIdOpnieuwIndienenRoute =
  BeheerAanmeldingenStudentRegistrationIdOpnieuwIndienenRouteImport.update({
    id: '/beheer/aanmeldingen/$studentRegistrationId/opnieuw-indienen',
    path: '/beheer/aanmeldingen/$studentRegistrationId/opnieuw-indienen',
    getParentRoute: () => rootRouteImport,
  } as any)
const BeheerMedewerkersOrganizationUserIdGekoppeldeCursistenIndexRoute =
  BeheerMedewerkersOrganizationUserIdGekoppeldeCursistenIndexRouteImport.update(
    {
      id: '/gekoppelde-cursisten/',
      path: '/gekoppelde-cursisten/',
      getParentRoute: () => BeheerMedewerkersOrganizationUserIdRouteRoute,
    } as any,
  )
const BeheerMedewerkersOrganizationUserIdGegevensIndexRoute =
  BeheerMedewerkersOrganizationUserIdGegevensIndexRouteImport.update({
    id: '/gegevens/',
    path: '/gegevens/',
    getParentRoute: () => BeheerMedewerkersOrganizationUserIdRouteRoute,
  } as any)
const BeheerGroepenGroupIdStudentsIndexRoute =
  BeheerGroepenGroupIdStudentsIndexRouteImport.update({
    id: '/students/',
    path: '/students/',
    getParentRoute: () => BeheerGroepenGroupIdRouteRoute,
  } as any)
const BeheerGroepenGroupIdLessenIndexRoute =
  BeheerGroepenGroupIdLessenIndexRouteImport.update({
    id: '/lessen/',
    path: '/lessen/',
    getParentRoute: () => BeheerGroepenGroupIdRouteRoute,
  } as any)
const BeheerGroepenGroupIdCorrespondentieIndexRoute =
  BeheerGroepenGroupIdCorrespondentieIndexRouteImport.update({
    id: '/correspondentie/',
    path: '/correspondentie/',
    getParentRoute: () => BeheerGroepenGroupIdRouteRoute,
  } as any)
const BeheerCursistenStudentIdVoortgangIndexRoute =
  BeheerCursistenStudentIdVoortgangIndexRouteImport.update({
    id: '/voortgang/',
    path: '/voortgang/',
    getParentRoute: () => BeheerCursistenStudentIdRouteRoute,
  } as any)
const BeheerCursistenStudentIdTweedeAanspreekpuntIndexRoute =
  BeheerCursistenStudentIdTweedeAanspreekpuntIndexRouteImport.update({
    id: '/tweede-aanspreekpunt/',
    path: '/tweede-aanspreekpunt/',
    getParentRoute: () => BeheerCursistenStudentIdRouteRoute,
  } as any)
const BeheerCursistenStudentIdRapportagesIndexRoute =
  BeheerCursistenStudentIdRapportagesIndexRouteImport.update({
    id: '/rapportages/',
    path: '/rapportages/',
    getParentRoute: () => BeheerCursistenStudentIdRouteRoute,
  } as any)
const BeheerCursistenStudentIdLessenIndexRoute =
  BeheerCursistenStudentIdLessenIndexRouteImport.update({
    id: '/lessen/',
    path: '/lessen/',
    getParentRoute: () => BeheerCursistenStudentIdRouteRoute,
  } as any)
const BeheerCursistenStudentIdIntakeIndexRoute =
  BeheerCursistenStudentIdIntakeIndexRouteImport.update({
    id: '/intake/',
    path: '/intake/',
    getParentRoute: () => BeheerCursistenStudentIdRouteRoute,
  } as any)
const BeheerCursistenStudentIdGegevensIndexRoute =
  BeheerCursistenStudentIdGegevensIndexRouteImport.update({
    id: '/gegevens/',
    path: '/gegevens/',
    getParentRoute: () => BeheerCursistenStudentIdRouteRoute,
  } as any)
const BeheerCursistenStudentIdCorrespondentieIndexRoute =
  BeheerCursistenStudentIdCorrespondentieIndexRouteImport.update({
    id: '/correspondentie/',
    path: '/correspondentie/',
    getParentRoute: () => BeheerCursistenStudentIdRouteRoute,
  } as any)
const BeheerContractenContractIdCorrespondentieIndexRoute =
  BeheerContractenContractIdCorrespondentieIndexRouteImport.update({
    id: '/correspondentie/',
    path: '/correspondentie/',
    getParentRoute: () => BeheerContractenContractIdRouteRoute,
  } as any)
const BeheerGroepenGroupIdCorrespondentieThreadIdRoute =
  BeheerGroepenGroupIdCorrespondentieThreadIdRouteImport.update({
    id: '/correspondentie/$threadId',
    path: '/correspondentie/$threadId',
    getParentRoute: () => BeheerGroepenGroupIdRouteRoute,
  } as any)
const BeheerCursistenStudentIdCorrespondentieThreadIdRoute =
  BeheerCursistenStudentIdCorrespondentieThreadIdRouteImport.update({
    id: '/correspondentie/$threadId',
    path: '/correspondentie/$threadId',
    getParentRoute: () => BeheerCursistenStudentIdRouteRoute,
  } as any)
const BeheerContractenContractIdOrganisatiesOrganizationRoute =
  BeheerContractenContractIdOrganisatiesOrganizationRouteImport.update({
    id: '/organisaties/$organization',
    path: '/organisaties/$organization',
    getParentRoute: () => BeheerContractenContractIdRouteRoute,
  } as any)
const BeheerContractenContractIdCorrespondentieThreadIdRoute =
  BeheerContractenContractIdCorrespondentieThreadIdRouteImport.update({
    id: '/correspondentie/$threadId',
    path: '/correspondentie/$threadId',
    getParentRoute: () => BeheerContractenContractIdRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/organisatie-profiel': typeof OrganisatieProfielRouteRouteWithChildren
  '/profiel': typeof ProfielRouteRouteWithChildren
  '/correspondentie/$threadId': typeof CorrespondentieThreadIdRoute
  '/login/$token': typeof LoginTokenRoute
  '/login/google_sso': typeof LoginGoogle_ssoRoute
  '/login/microsoft_sso': typeof LoginMicrosoft_ssoRoute
  '/beheer/': typeof BeheerIndexRoute
  '/correspondentie/': typeof CorrespondentieIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/login/': typeof LoginIndexRoute
  '/organisatie-profiel/': typeof OrganisatieProfielIndexRoute
  '/beheer/contracten/$contractId': typeof BeheerContractenContractIdRouteRouteWithChildren
  '/beheer/cursisten/$studentId': typeof BeheerCursistenStudentIdRouteRouteWithChildren
  '/beheer/groepen/$groupId': typeof BeheerGroepenGroupIdRouteRouteWithChildren
  '/beheer/medewerkers/$organizationUserId': typeof BeheerMedewerkersOrganizationUserIdRouteRouteWithChildren
  '/beheer/cursisten/aanmaken': typeof BeheerCursistenAanmakenRoute
  '/beheer/medewerkers/aanmaken': typeof BeheerMedewerkersAanmakenRoute
  '/organisatie-profiel/medewerkers/aanmaken': typeof OrganisatieProfielMedewerkersAanmakenRoute
  '/auth/failed_sso/': typeof AuthFailed_ssoIndexRoute
  '/auth/sso_callback/': typeof AuthSso_callbackIndexRoute
  '/beheer/aanmeldingen/': typeof BeheerAanmeldingenIndexRoute
  '/beheer/contracten/': typeof BeheerContractenIndexRoute
  '/beheer/cursisten/': typeof BeheerCursistenIndexRoute
  '/beheer/gebruikers/': typeof BeheerGebruikersIndexRoute
  '/beheer/groepen/': typeof BeheerGroepenIndexRoute
  '/beheer/medewerkers/': typeof BeheerMedewerkersIndexRoute
  '/organisatie-profiel/gegevens/': typeof OrganisatieProfielGegevensIndexRoute
  '/organisatie-profiel/medewerkers/': typeof OrganisatieProfielMedewerkersIndexRoute
  '/profiel/gegevens/': typeof ProfielGegevensIndexRoute
  '/profiel/gekoppelde-cursisten/': typeof ProfielGekoppeldeCursistenIndexRoute
  '/beheer/aanmeldingen/$studentRegistrationId/opnieuw-indienen': typeof BeheerAanmeldingenStudentRegistrationIdOpnieuwIndienenRoute
  '/beheer/contracten/$contractId/': typeof BeheerContractenContractIdIndexRoute
  '/beheer/contracten/$contractId/correspondentie/$threadId': typeof BeheerContractenContractIdCorrespondentieThreadIdRoute
  '/beheer/contracten/$contractId/organisaties/$organization': typeof BeheerContractenContractIdOrganisatiesOrganizationRoute
  '/beheer/cursisten/$studentId/correspondentie/$threadId': typeof BeheerCursistenStudentIdCorrespondentieThreadIdRoute
  '/beheer/groepen/$groupId/correspondentie/$threadId': typeof BeheerGroepenGroupIdCorrespondentieThreadIdRoute
  '/beheer/contracten/$contractId/correspondentie/': typeof BeheerContractenContractIdCorrespondentieIndexRoute
  '/beheer/cursisten/$studentId/correspondentie/': typeof BeheerCursistenStudentIdCorrespondentieIndexRoute
  '/beheer/cursisten/$studentId/gegevens/': typeof BeheerCursistenStudentIdGegevensIndexRoute
  '/beheer/cursisten/$studentId/intake/': typeof BeheerCursistenStudentIdIntakeIndexRoute
  '/beheer/cursisten/$studentId/lessen/': typeof BeheerCursistenStudentIdLessenIndexRoute
  '/beheer/cursisten/$studentId/rapportages/': typeof BeheerCursistenStudentIdRapportagesIndexRoute
  '/beheer/cursisten/$studentId/tweede-aanspreekpunt/': typeof BeheerCursistenStudentIdTweedeAanspreekpuntIndexRoute
  '/beheer/cursisten/$studentId/voortgang/': typeof BeheerCursistenStudentIdVoortgangIndexRoute
  '/beheer/groepen/$groupId/correspondentie/': typeof BeheerGroepenGroupIdCorrespondentieIndexRoute
  '/beheer/groepen/$groupId/lessen/': typeof BeheerGroepenGroupIdLessenIndexRoute
  '/beheer/groepen/$groupId/students/': typeof BeheerGroepenGroupIdStudentsIndexRoute
  '/beheer/medewerkers/$organizationUserId/gegevens/': typeof BeheerMedewerkersOrganizationUserIdGegevensIndexRoute
  '/beheer/medewerkers/$organizationUserId/gekoppelde-cursisten/': typeof BeheerMedewerkersOrganizationUserIdGekoppeldeCursistenIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/profiel': typeof ProfielRouteRouteWithChildren
  '/correspondentie/$threadId': typeof CorrespondentieThreadIdRoute
  '/login/$token': typeof LoginTokenRoute
  '/login/google_sso': typeof LoginGoogle_ssoRoute
  '/login/microsoft_sso': typeof LoginMicrosoft_ssoRoute
  '/beheer': typeof BeheerIndexRoute
  '/correspondentie': typeof CorrespondentieIndexRoute
  '/dashboard': typeof DashboardIndexRoute
  '/login': typeof LoginIndexRoute
  '/organisatie-profiel': typeof OrganisatieProfielIndexRoute
  '/beheer/cursisten/$studentId': typeof BeheerCursistenStudentIdRouteRouteWithChildren
  '/beheer/groepen/$groupId': typeof BeheerGroepenGroupIdRouteRouteWithChildren
  '/beheer/medewerkers/$organizationUserId': typeof BeheerMedewerkersOrganizationUserIdRouteRouteWithChildren
  '/beheer/cursisten/aanmaken': typeof BeheerCursistenAanmakenRoute
  '/beheer/medewerkers/aanmaken': typeof BeheerMedewerkersAanmakenRoute
  '/organisatie-profiel/medewerkers/aanmaken': typeof OrganisatieProfielMedewerkersAanmakenRoute
  '/auth/failed_sso': typeof AuthFailed_ssoIndexRoute
  '/auth/sso_callback': typeof AuthSso_callbackIndexRoute
  '/beheer/aanmeldingen': typeof BeheerAanmeldingenIndexRoute
  '/beheer/contracten': typeof BeheerContractenIndexRoute
  '/beheer/cursisten': typeof BeheerCursistenIndexRoute
  '/beheer/gebruikers': typeof BeheerGebruikersIndexRoute
  '/beheer/groepen': typeof BeheerGroepenIndexRoute
  '/beheer/medewerkers': typeof BeheerMedewerkersIndexRoute
  '/organisatie-profiel/gegevens': typeof OrganisatieProfielGegevensIndexRoute
  '/organisatie-profiel/medewerkers': typeof OrganisatieProfielMedewerkersIndexRoute
  '/profiel/gegevens': typeof ProfielGegevensIndexRoute
  '/profiel/gekoppelde-cursisten': typeof ProfielGekoppeldeCursistenIndexRoute
  '/beheer/aanmeldingen/$studentRegistrationId/opnieuw-indienen': typeof BeheerAanmeldingenStudentRegistrationIdOpnieuwIndienenRoute
  '/beheer/contracten/$contractId': typeof BeheerContractenContractIdIndexRoute
  '/beheer/contracten/$contractId/correspondentie/$threadId': typeof BeheerContractenContractIdCorrespondentieThreadIdRoute
  '/beheer/contracten/$contractId/organisaties/$organization': typeof BeheerContractenContractIdOrganisatiesOrganizationRoute
  '/beheer/cursisten/$studentId/correspondentie/$threadId': typeof BeheerCursistenStudentIdCorrespondentieThreadIdRoute
  '/beheer/groepen/$groupId/correspondentie/$threadId': typeof BeheerGroepenGroupIdCorrespondentieThreadIdRoute
  '/beheer/contracten/$contractId/correspondentie': typeof BeheerContractenContractIdCorrespondentieIndexRoute
  '/beheer/cursisten/$studentId/correspondentie': typeof BeheerCursistenStudentIdCorrespondentieIndexRoute
  '/beheer/cursisten/$studentId/gegevens': typeof BeheerCursistenStudentIdGegevensIndexRoute
  '/beheer/cursisten/$studentId/intake': typeof BeheerCursistenStudentIdIntakeIndexRoute
  '/beheer/cursisten/$studentId/lessen': typeof BeheerCursistenStudentIdLessenIndexRoute
  '/beheer/cursisten/$studentId/rapportages': typeof BeheerCursistenStudentIdRapportagesIndexRoute
  '/beheer/cursisten/$studentId/tweede-aanspreekpunt': typeof BeheerCursistenStudentIdTweedeAanspreekpuntIndexRoute
  '/beheer/cursisten/$studentId/voortgang': typeof BeheerCursistenStudentIdVoortgangIndexRoute
  '/beheer/groepen/$groupId/correspondentie': typeof BeheerGroepenGroupIdCorrespondentieIndexRoute
  '/beheer/groepen/$groupId/lessen': typeof BeheerGroepenGroupIdLessenIndexRoute
  '/beheer/groepen/$groupId/students': typeof BeheerGroepenGroupIdStudentsIndexRoute
  '/beheer/medewerkers/$organizationUserId/gegevens': typeof BeheerMedewerkersOrganizationUserIdGegevensIndexRoute
  '/beheer/medewerkers/$organizationUserId/gekoppelde-cursisten': typeof BeheerMedewerkersOrganizationUserIdGekoppeldeCursistenIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/organisatie-profiel': typeof OrganisatieProfielRouteRouteWithChildren
  '/profiel': typeof ProfielRouteRouteWithChildren
  '/correspondentie/$threadId': typeof CorrespondentieThreadIdRoute
  '/login/$token': typeof LoginTokenRoute
  '/login/google_sso': typeof LoginGoogle_ssoRoute
  '/login/microsoft_sso': typeof LoginMicrosoft_ssoRoute
  '/beheer/': typeof BeheerIndexRoute
  '/correspondentie/': typeof CorrespondentieIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/login/': typeof LoginIndexRoute
  '/organisatie-profiel/': typeof OrganisatieProfielIndexRoute
  '/beheer/contracten/$contractId': typeof BeheerContractenContractIdRouteRouteWithChildren
  '/beheer/cursisten/$studentId': typeof BeheerCursistenStudentIdRouteRouteWithChildren
  '/beheer/groepen/$groupId': typeof BeheerGroepenGroupIdRouteRouteWithChildren
  '/beheer/medewerkers/$organizationUserId': typeof BeheerMedewerkersOrganizationUserIdRouteRouteWithChildren
  '/beheer/cursisten/aanmaken': typeof BeheerCursistenAanmakenRoute
  '/beheer/medewerkers/aanmaken': typeof BeheerMedewerkersAanmakenRoute
  '/organisatie-profiel/medewerkers/aanmaken': typeof OrganisatieProfielMedewerkersAanmakenRoute
  '/auth/failed_sso/': typeof AuthFailed_ssoIndexRoute
  '/auth/sso_callback/': typeof AuthSso_callbackIndexRoute
  '/beheer/aanmeldingen/': typeof BeheerAanmeldingenIndexRoute
  '/beheer/contracten/': typeof BeheerContractenIndexRoute
  '/beheer/cursisten/': typeof BeheerCursistenIndexRoute
  '/beheer/gebruikers/': typeof BeheerGebruikersIndexRoute
  '/beheer/groepen/': typeof BeheerGroepenIndexRoute
  '/beheer/medewerkers/': typeof BeheerMedewerkersIndexRoute
  '/organisatie-profiel/gegevens/': typeof OrganisatieProfielGegevensIndexRoute
  '/organisatie-profiel/medewerkers/': typeof OrganisatieProfielMedewerkersIndexRoute
  '/profiel/gegevens/': typeof ProfielGegevensIndexRoute
  '/profiel/gekoppelde-cursisten/': typeof ProfielGekoppeldeCursistenIndexRoute
  '/beheer/aanmeldingen/$studentRegistrationId/opnieuw-indienen': typeof BeheerAanmeldingenStudentRegistrationIdOpnieuwIndienenRoute
  '/beheer/contracten/$contractId/': typeof BeheerContractenContractIdIndexRoute
  '/beheer/contracten/$contractId/correspondentie/$threadId': typeof BeheerContractenContractIdCorrespondentieThreadIdRoute
  '/beheer/contracten/$contractId/organisaties/$organization': typeof BeheerContractenContractIdOrganisatiesOrganizationRoute
  '/beheer/cursisten/$studentId/correspondentie/$threadId': typeof BeheerCursistenStudentIdCorrespondentieThreadIdRoute
  '/beheer/groepen/$groupId/correspondentie/$threadId': typeof BeheerGroepenGroupIdCorrespondentieThreadIdRoute
  '/beheer/contracten/$contractId/correspondentie/': typeof BeheerContractenContractIdCorrespondentieIndexRoute
  '/beheer/cursisten/$studentId/correspondentie/': typeof BeheerCursistenStudentIdCorrespondentieIndexRoute
  '/beheer/cursisten/$studentId/gegevens/': typeof BeheerCursistenStudentIdGegevensIndexRoute
  '/beheer/cursisten/$studentId/intake/': typeof BeheerCursistenStudentIdIntakeIndexRoute
  '/beheer/cursisten/$studentId/lessen/': typeof BeheerCursistenStudentIdLessenIndexRoute
  '/beheer/cursisten/$studentId/rapportages/': typeof BeheerCursistenStudentIdRapportagesIndexRoute
  '/beheer/cursisten/$studentId/tweede-aanspreekpunt/': typeof BeheerCursistenStudentIdTweedeAanspreekpuntIndexRoute
  '/beheer/cursisten/$studentId/voortgang/': typeof BeheerCursistenStudentIdVoortgangIndexRoute
  '/beheer/groepen/$groupId/correspondentie/': typeof BeheerGroepenGroupIdCorrespondentieIndexRoute
  '/beheer/groepen/$groupId/lessen/': typeof BeheerGroepenGroupIdLessenIndexRoute
  '/beheer/groepen/$groupId/students/': typeof BeheerGroepenGroupIdStudentsIndexRoute
  '/beheer/medewerkers/$organizationUserId/gegevens/': typeof BeheerMedewerkersOrganizationUserIdGegevensIndexRoute
  '/beheer/medewerkers/$organizationUserId/gekoppelde-cursisten/': typeof BeheerMedewerkersOrganizationUserIdGekoppeldeCursistenIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/organisatie-profiel'
    | '/profiel'
    | '/correspondentie/$threadId'
    | '/login/$token'
    | '/login/google_sso'
    | '/login/microsoft_sso'
    | '/beheer/'
    | '/correspondentie/'
    | '/dashboard/'
    | '/login/'
    | '/organisatie-profiel/'
    | '/beheer/contracten/$contractId'
    | '/beheer/cursisten/$studentId'
    | '/beheer/groepen/$groupId'
    | '/beheer/medewerkers/$organizationUserId'
    | '/beheer/cursisten/aanmaken'
    | '/beheer/medewerkers/aanmaken'
    | '/organisatie-profiel/medewerkers/aanmaken'
    | '/auth/failed_sso/'
    | '/auth/sso_callback/'
    | '/beheer/aanmeldingen/'
    | '/beheer/contracten/'
    | '/beheer/cursisten/'
    | '/beheer/gebruikers/'
    | '/beheer/groepen/'
    | '/beheer/medewerkers/'
    | '/organisatie-profiel/gegevens/'
    | '/organisatie-profiel/medewerkers/'
    | '/profiel/gegevens/'
    | '/profiel/gekoppelde-cursisten/'
    | '/beheer/aanmeldingen/$studentRegistrationId/opnieuw-indienen'
    | '/beheer/contracten/$contractId/'
    | '/beheer/contracten/$contractId/correspondentie/$threadId'
    | '/beheer/contracten/$contractId/organisaties/$organization'
    | '/beheer/cursisten/$studentId/correspondentie/$threadId'
    | '/beheer/groepen/$groupId/correspondentie/$threadId'
    | '/beheer/contracten/$contractId/correspondentie/'
    | '/beheer/cursisten/$studentId/correspondentie/'
    | '/beheer/cursisten/$studentId/gegevens/'
    | '/beheer/cursisten/$studentId/intake/'
    | '/beheer/cursisten/$studentId/lessen/'
    | '/beheer/cursisten/$studentId/rapportages/'
    | '/beheer/cursisten/$studentId/tweede-aanspreekpunt/'
    | '/beheer/cursisten/$studentId/voortgang/'
    | '/beheer/groepen/$groupId/correspondentie/'
    | '/beheer/groepen/$groupId/lessen/'
    | '/beheer/groepen/$groupId/students/'
    | '/beheer/medewerkers/$organizationUserId/gegevens/'
    | '/beheer/medewerkers/$organizationUserId/gekoppelde-cursisten/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/profiel'
    | '/correspondentie/$threadId'
    | '/login/$token'
    | '/login/google_sso'
    | '/login/microsoft_sso'
    | '/beheer'
    | '/correspondentie'
    | '/dashboard'
    | '/login'
    | '/organisatie-profiel'
    | '/beheer/cursisten/$studentId'
    | '/beheer/groepen/$groupId'
    | '/beheer/medewerkers/$organizationUserId'
    | '/beheer/cursisten/aanmaken'
    | '/beheer/medewerkers/aanmaken'
    | '/organisatie-profiel/medewerkers/aanmaken'
    | '/auth/failed_sso'
    | '/auth/sso_callback'
    | '/beheer/aanmeldingen'
    | '/beheer/contracten'
    | '/beheer/cursisten'
    | '/beheer/gebruikers'
    | '/beheer/groepen'
    | '/beheer/medewerkers'
    | '/organisatie-profiel/gegevens'
    | '/organisatie-profiel/medewerkers'
    | '/profiel/gegevens'
    | '/profiel/gekoppelde-cursisten'
    | '/beheer/aanmeldingen/$studentRegistrationId/opnieuw-indienen'
    | '/beheer/contracten/$contractId'
    | '/beheer/contracten/$contractId/correspondentie/$threadId'
    | '/beheer/contracten/$contractId/organisaties/$organization'
    | '/beheer/cursisten/$studentId/correspondentie/$threadId'
    | '/beheer/groepen/$groupId/correspondentie/$threadId'
    | '/beheer/contracten/$contractId/correspondentie'
    | '/beheer/cursisten/$studentId/correspondentie'
    | '/beheer/cursisten/$studentId/gegevens'
    | '/beheer/cursisten/$studentId/intake'
    | '/beheer/cursisten/$studentId/lessen'
    | '/beheer/cursisten/$studentId/rapportages'
    | '/beheer/cursisten/$studentId/tweede-aanspreekpunt'
    | '/beheer/cursisten/$studentId/voortgang'
    | '/beheer/groepen/$groupId/correspondentie'
    | '/beheer/groepen/$groupId/lessen'
    | '/beheer/groepen/$groupId/students'
    | '/beheer/medewerkers/$organizationUserId/gegevens'
    | '/beheer/medewerkers/$organizationUserId/gekoppelde-cursisten'
  id:
    | '__root__'
    | '/'
    | '/organisatie-profiel'
    | '/profiel'
    | '/correspondentie/$threadId'
    | '/login/$token'
    | '/login/google_sso'
    | '/login/microsoft_sso'
    | '/beheer/'
    | '/correspondentie/'
    | '/dashboard/'
    | '/login/'
    | '/organisatie-profiel/'
    | '/beheer/contracten/$contractId'
    | '/beheer/cursisten/$studentId'
    | '/beheer/groepen/$groupId'
    | '/beheer/medewerkers/$organizationUserId'
    | '/beheer/cursisten/aanmaken'
    | '/beheer/medewerkers/aanmaken'
    | '/organisatie-profiel/medewerkers/aanmaken'
    | '/auth/failed_sso/'
    | '/auth/sso_callback/'
    | '/beheer/aanmeldingen/'
    | '/beheer/contracten/'
    | '/beheer/cursisten/'
    | '/beheer/gebruikers/'
    | '/beheer/groepen/'
    | '/beheer/medewerkers/'
    | '/organisatie-profiel/gegevens/'
    | '/organisatie-profiel/medewerkers/'
    | '/profiel/gegevens/'
    | '/profiel/gekoppelde-cursisten/'
    | '/beheer/aanmeldingen/$studentRegistrationId/opnieuw-indienen'
    | '/beheer/contracten/$contractId/'
    | '/beheer/contracten/$contractId/correspondentie/$threadId'
    | '/beheer/contracten/$contractId/organisaties/$organization'
    | '/beheer/cursisten/$studentId/correspondentie/$threadId'
    | '/beheer/groepen/$groupId/correspondentie/$threadId'
    | '/beheer/contracten/$contractId/correspondentie/'
    | '/beheer/cursisten/$studentId/correspondentie/'
    | '/beheer/cursisten/$studentId/gegevens/'
    | '/beheer/cursisten/$studentId/intake/'
    | '/beheer/cursisten/$studentId/lessen/'
    | '/beheer/cursisten/$studentId/rapportages/'
    | '/beheer/cursisten/$studentId/tweede-aanspreekpunt/'
    | '/beheer/cursisten/$studentId/voortgang/'
    | '/beheer/groepen/$groupId/correspondentie/'
    | '/beheer/groepen/$groupId/lessen/'
    | '/beheer/groepen/$groupId/students/'
    | '/beheer/medewerkers/$organizationUserId/gegevens/'
    | '/beheer/medewerkers/$organizationUserId/gekoppelde-cursisten/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  OrganisatieProfielRouteRoute: typeof OrganisatieProfielRouteRouteWithChildren
  ProfielRouteRoute: typeof ProfielRouteRouteWithChildren
  CorrespondentieThreadIdRoute: typeof CorrespondentieThreadIdRoute
  LoginTokenRoute: typeof LoginTokenRoute
  LoginGoogle_ssoRoute: typeof LoginGoogle_ssoRoute
  LoginMicrosoft_ssoRoute: typeof LoginMicrosoft_ssoRoute
  BeheerIndexRoute: typeof BeheerIndexRoute
  CorrespondentieIndexRoute: typeof CorrespondentieIndexRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
  LoginIndexRoute: typeof LoginIndexRoute
  BeheerContractenContractIdRouteRoute: typeof BeheerContractenContractIdRouteRouteWithChildren
  BeheerCursistenStudentIdRouteRoute: typeof BeheerCursistenStudentIdRouteRouteWithChildren
  BeheerGroepenGroupIdRouteRoute: typeof BeheerGroepenGroupIdRouteRouteWithChildren
  BeheerMedewerkersOrganizationUserIdRouteRoute: typeof BeheerMedewerkersOrganizationUserIdRouteRouteWithChildren
  BeheerCursistenAanmakenRoute: typeof BeheerCursistenAanmakenRoute
  BeheerMedewerkersAanmakenRoute: typeof BeheerMedewerkersAanmakenRoute
  AuthFailed_ssoIndexRoute: typeof AuthFailed_ssoIndexRoute
  AuthSso_callbackIndexRoute: typeof AuthSso_callbackIndexRoute
  BeheerAanmeldingenIndexRoute: typeof BeheerAanmeldingenIndexRoute
  BeheerContractenIndexRoute: typeof BeheerContractenIndexRoute
  BeheerCursistenIndexRoute: typeof BeheerCursistenIndexRoute
  BeheerGebruikersIndexRoute: typeof BeheerGebruikersIndexRoute
  BeheerGroepenIndexRoute: typeof BeheerGroepenIndexRoute
  BeheerMedewerkersIndexRoute: typeof BeheerMedewerkersIndexRoute
  BeheerAanmeldingenStudentRegistrationIdOpnieuwIndienenRoute: typeof BeheerAanmeldingenStudentRegistrationIdOpnieuwIndienenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/profiel': {
      id: '/profiel'
      path: '/profiel'
      fullPath: '/profiel'
      preLoaderRoute: typeof ProfielRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organisatie-profiel': {
      id: '/organisatie-profiel'
      path: '/organisatie-profiel'
      fullPath: '/organisatie-profiel'
      preLoaderRoute: typeof OrganisatieProfielRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organisatie-profiel/': {
      id: '/organisatie-profiel/'
      path: '/'
      fullPath: '/organisatie-profiel/'
      preLoaderRoute: typeof OrganisatieProfielIndexRouteImport
      parentRoute: typeof OrganisatieProfielRouteRoute
    }
    '/login/': {
      id: '/login/'
      path: '/login'
      fullPath: '/login/'
      preLoaderRoute: typeof LoginIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/correspondentie/': {
      id: '/correspondentie/'
      path: '/correspondentie'
      fullPath: '/correspondentie/'
      preLoaderRoute: typeof CorrespondentieIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer/': {
      id: '/beheer/'
      path: '/beheer'
      fullPath: '/beheer/'
      preLoaderRoute: typeof BeheerIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/microsoft_sso': {
      id: '/login/microsoft_sso'
      path: '/login/microsoft_sso'
      fullPath: '/login/microsoft_sso'
      preLoaderRoute: typeof LoginMicrosoft_ssoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/google_sso': {
      id: '/login/google_sso'
      path: '/login/google_sso'
      fullPath: '/login/google_sso'
      preLoaderRoute: typeof LoginGoogle_ssoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/$token': {
      id: '/login/$token'
      path: '/login/$token'
      fullPath: '/login/$token'
      preLoaderRoute: typeof LoginTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/correspondentie/$threadId': {
      id: '/correspondentie/$threadId'
      path: '/correspondentie/$threadId'
      fullPath: '/correspondentie/$threadId'
      preLoaderRoute: typeof CorrespondentieThreadIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profiel/gekoppelde-cursisten/': {
      id: '/profiel/gekoppelde-cursisten/'
      path: '/gekoppelde-cursisten'
      fullPath: '/profiel/gekoppelde-cursisten/'
      preLoaderRoute: typeof ProfielGekoppeldeCursistenIndexRouteImport
      parentRoute: typeof ProfielRouteRoute
    }
    '/profiel/gegevens/': {
      id: '/profiel/gegevens/'
      path: '/gegevens'
      fullPath: '/profiel/gegevens/'
      preLoaderRoute: typeof ProfielGegevensIndexRouteImport
      parentRoute: typeof ProfielRouteRoute
    }
    '/organisatie-profiel/medewerkers/': {
      id: '/organisatie-profiel/medewerkers/'
      path: '/medewerkers'
      fullPath: '/organisatie-profiel/medewerkers/'
      preLoaderRoute: typeof OrganisatieProfielMedewerkersIndexRouteImport
      parentRoute: typeof OrganisatieProfielRouteRoute
    }
    '/organisatie-profiel/gegevens/': {
      id: '/organisatie-profiel/gegevens/'
      path: '/gegevens'
      fullPath: '/organisatie-profiel/gegevens/'
      preLoaderRoute: typeof OrganisatieProfielGegevensIndexRouteImport
      parentRoute: typeof OrganisatieProfielRouteRoute
    }
    '/beheer/medewerkers/': {
      id: '/beheer/medewerkers/'
      path: '/beheer/medewerkers'
      fullPath: '/beheer/medewerkers/'
      preLoaderRoute: typeof BeheerMedewerkersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer/groepen/': {
      id: '/beheer/groepen/'
      path: '/beheer/groepen'
      fullPath: '/beheer/groepen/'
      preLoaderRoute: typeof BeheerGroepenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer/gebruikers/': {
      id: '/beheer/gebruikers/'
      path: '/beheer/gebruikers'
      fullPath: '/beheer/gebruikers/'
      preLoaderRoute: typeof BeheerGebruikersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer/cursisten/': {
      id: '/beheer/cursisten/'
      path: '/beheer/cursisten'
      fullPath: '/beheer/cursisten/'
      preLoaderRoute: typeof BeheerCursistenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer/contracten/': {
      id: '/beheer/contracten/'
      path: '/beheer/contracten'
      fullPath: '/beheer/contracten/'
      preLoaderRoute: typeof BeheerContractenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer/aanmeldingen/': {
      id: '/beheer/aanmeldingen/'
      path: '/beheer/aanmeldingen'
      fullPath: '/beheer/aanmeldingen/'
      preLoaderRoute: typeof BeheerAanmeldingenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/sso_callback/': {
      id: '/auth/sso_callback/'
      path: '/auth/sso_callback'
      fullPath: '/auth/sso_callback/'
      preLoaderRoute: typeof AuthSso_callbackIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/failed_sso/': {
      id: '/auth/failed_sso/'
      path: '/auth/failed_sso'
      fullPath: '/auth/failed_sso/'
      preLoaderRoute: typeof AuthFailed_ssoIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organisatie-profiel/medewerkers/aanmaken': {
      id: '/organisatie-profiel/medewerkers/aanmaken'
      path: '/medewerkers/aanmaken'
      fullPath: '/organisatie-profiel/medewerkers/aanmaken'
      preLoaderRoute: typeof OrganisatieProfielMedewerkersAanmakenRouteImport
      parentRoute: typeof OrganisatieProfielRouteRoute
    }
    '/beheer/medewerkers/aanmaken': {
      id: '/beheer/medewerkers/aanmaken'
      path: '/beheer/medewerkers/aanmaken'
      fullPath: '/beheer/medewerkers/aanmaken'
      preLoaderRoute: typeof BeheerMedewerkersAanmakenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer/cursisten/aanmaken': {
      id: '/beheer/cursisten/aanmaken'
      path: '/beheer/cursisten/aanmaken'
      fullPath: '/beheer/cursisten/aanmaken'
      preLoaderRoute: typeof BeheerCursistenAanmakenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer/medewerkers/$organizationUserId': {
      id: '/beheer/medewerkers/$organizationUserId'
      path: '/beheer/medewerkers/$organizationUserId'
      fullPath: '/beheer/medewerkers/$organizationUserId'
      preLoaderRoute: typeof BeheerMedewerkersOrganizationUserIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer/groepen/$groupId': {
      id: '/beheer/groepen/$groupId'
      path: '/beheer/groepen/$groupId'
      fullPath: '/beheer/groepen/$groupId'
      preLoaderRoute: typeof BeheerGroepenGroupIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer/cursisten/$studentId': {
      id: '/beheer/cursisten/$studentId'
      path: '/beheer/cursisten/$studentId'
      fullPath: '/beheer/cursisten/$studentId'
      preLoaderRoute: typeof BeheerCursistenStudentIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer/contracten/$contractId': {
      id: '/beheer/contracten/$contractId'
      path: '/beheer/contracten/$contractId'
      fullPath: '/beheer/contracten/$contractId'
      preLoaderRoute: typeof BeheerContractenContractIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer/contracten/$contractId/': {
      id: '/beheer/contracten/$contractId/'
      path: '/'
      fullPath: '/beheer/contracten/$contractId/'
      preLoaderRoute: typeof BeheerContractenContractIdIndexRouteImport
      parentRoute: typeof BeheerContractenContractIdRouteRoute
    }
    '/beheer/aanmeldingen/$studentRegistrationId/opnieuw-indienen': {
      id: '/beheer/aanmeldingen/$studentRegistrationId/opnieuw-indienen'
      path: '/beheer/aanmeldingen/$studentRegistrationId/opnieuw-indienen'
      fullPath: '/beheer/aanmeldingen/$studentRegistrationId/opnieuw-indienen'
      preLoaderRoute: typeof BeheerAanmeldingenStudentRegistrationIdOpnieuwIndienenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer/medewerkers/$organizationUserId/gekoppelde-cursisten/': {
      id: '/beheer/medewerkers/$organizationUserId/gekoppelde-cursisten/'
      path: '/gekoppelde-cursisten'
      fullPath: '/beheer/medewerkers/$organizationUserId/gekoppelde-cursisten/'
      preLoaderRoute: typeof BeheerMedewerkersOrganizationUserIdGekoppeldeCursistenIndexRouteImport
      parentRoute: typeof BeheerMedewerkersOrganizationUserIdRouteRoute
    }
    '/beheer/medewerkers/$organizationUserId/gegevens/': {
      id: '/beheer/medewerkers/$organizationUserId/gegevens/'
      path: '/gegevens'
      fullPath: '/beheer/medewerkers/$organizationUserId/gegevens/'
      preLoaderRoute: typeof BeheerMedewerkersOrganizationUserIdGegevensIndexRouteImport
      parentRoute: typeof BeheerMedewerkersOrganizationUserIdRouteRoute
    }
    '/beheer/groepen/$groupId/students/': {
      id: '/beheer/groepen/$groupId/students/'
      path: '/students'
      fullPath: '/beheer/groepen/$groupId/students/'
      preLoaderRoute: typeof BeheerGroepenGroupIdStudentsIndexRouteImport
      parentRoute: typeof BeheerGroepenGroupIdRouteRoute
    }
    '/beheer/groepen/$groupId/lessen/': {
      id: '/beheer/groepen/$groupId/lessen/'
      path: '/lessen'
      fullPath: '/beheer/groepen/$groupId/lessen/'
      preLoaderRoute: typeof BeheerGroepenGroupIdLessenIndexRouteImport
      parentRoute: typeof BeheerGroepenGroupIdRouteRoute
    }
    '/beheer/groepen/$groupId/correspondentie/': {
      id: '/beheer/groepen/$groupId/correspondentie/'
      path: '/correspondentie'
      fullPath: '/beheer/groepen/$groupId/correspondentie/'
      preLoaderRoute: typeof BeheerGroepenGroupIdCorrespondentieIndexRouteImport
      parentRoute: typeof BeheerGroepenGroupIdRouteRoute
    }
    '/beheer/cursisten/$studentId/voortgang/': {
      id: '/beheer/cursisten/$studentId/voortgang/'
      path: '/voortgang'
      fullPath: '/beheer/cursisten/$studentId/voortgang/'
      preLoaderRoute: typeof BeheerCursistenStudentIdVoortgangIndexRouteImport
      parentRoute: typeof BeheerCursistenStudentIdRouteRoute
    }
    '/beheer/cursisten/$studentId/tweede-aanspreekpunt/': {
      id: '/beheer/cursisten/$studentId/tweede-aanspreekpunt/'
      path: '/tweede-aanspreekpunt'
      fullPath: '/beheer/cursisten/$studentId/tweede-aanspreekpunt/'
      preLoaderRoute: typeof BeheerCursistenStudentIdTweedeAanspreekpuntIndexRouteImport
      parentRoute: typeof BeheerCursistenStudentIdRouteRoute
    }
    '/beheer/cursisten/$studentId/rapportages/': {
      id: '/beheer/cursisten/$studentId/rapportages/'
      path: '/rapportages'
      fullPath: '/beheer/cursisten/$studentId/rapportages/'
      preLoaderRoute: typeof BeheerCursistenStudentIdRapportagesIndexRouteImport
      parentRoute: typeof BeheerCursistenStudentIdRouteRoute
    }
    '/beheer/cursisten/$studentId/lessen/': {
      id: '/beheer/cursisten/$studentId/lessen/'
      path: '/lessen'
      fullPath: '/beheer/cursisten/$studentId/lessen/'
      preLoaderRoute: typeof BeheerCursistenStudentIdLessenIndexRouteImport
      parentRoute: typeof BeheerCursistenStudentIdRouteRoute
    }
    '/beheer/cursisten/$studentId/intake/': {
      id: '/beheer/cursisten/$studentId/intake/'
      path: '/intake'
      fullPath: '/beheer/cursisten/$studentId/intake/'
      preLoaderRoute: typeof BeheerCursistenStudentIdIntakeIndexRouteImport
      parentRoute: typeof BeheerCursistenStudentIdRouteRoute
    }
    '/beheer/cursisten/$studentId/gegevens/': {
      id: '/beheer/cursisten/$studentId/gegevens/'
      path: '/gegevens'
      fullPath: '/beheer/cursisten/$studentId/gegevens/'
      preLoaderRoute: typeof BeheerCursistenStudentIdGegevensIndexRouteImport
      parentRoute: typeof BeheerCursistenStudentIdRouteRoute
    }
    '/beheer/cursisten/$studentId/correspondentie/': {
      id: '/beheer/cursisten/$studentId/correspondentie/'
      path: '/correspondentie'
      fullPath: '/beheer/cursisten/$studentId/correspondentie/'
      preLoaderRoute: typeof BeheerCursistenStudentIdCorrespondentieIndexRouteImport
      parentRoute: typeof BeheerCursistenStudentIdRouteRoute
    }
    '/beheer/contracten/$contractId/correspondentie/': {
      id: '/beheer/contracten/$contractId/correspondentie/'
      path: '/correspondentie'
      fullPath: '/beheer/contracten/$contractId/correspondentie/'
      preLoaderRoute: typeof BeheerContractenContractIdCorrespondentieIndexRouteImport
      parentRoute: typeof BeheerContractenContractIdRouteRoute
    }
    '/beheer/groepen/$groupId/correspondentie/$threadId': {
      id: '/beheer/groepen/$groupId/correspondentie/$threadId'
      path: '/correspondentie/$threadId'
      fullPath: '/beheer/groepen/$groupId/correspondentie/$threadId'
      preLoaderRoute: typeof BeheerGroepenGroupIdCorrespondentieThreadIdRouteImport
      parentRoute: typeof BeheerGroepenGroupIdRouteRoute
    }
    '/beheer/cursisten/$studentId/correspondentie/$threadId': {
      id: '/beheer/cursisten/$studentId/correspondentie/$threadId'
      path: '/correspondentie/$threadId'
      fullPath: '/beheer/cursisten/$studentId/correspondentie/$threadId'
      preLoaderRoute: typeof BeheerCursistenStudentIdCorrespondentieThreadIdRouteImport
      parentRoute: typeof BeheerCursistenStudentIdRouteRoute
    }
    '/beheer/contracten/$contractId/organisaties/$organization': {
      id: '/beheer/contracten/$contractId/organisaties/$organization'
      path: '/organisaties/$organization'
      fullPath: '/beheer/contracten/$contractId/organisaties/$organization'
      preLoaderRoute: typeof BeheerContractenContractIdOrganisatiesOrganizationRouteImport
      parentRoute: typeof BeheerContractenContractIdRouteRoute
    }
    '/beheer/contracten/$contractId/correspondentie/$threadId': {
      id: '/beheer/contracten/$contractId/correspondentie/$threadId'
      path: '/correspondentie/$threadId'
      fullPath: '/beheer/contracten/$contractId/correspondentie/$threadId'
      preLoaderRoute: typeof BeheerContractenContractIdCorrespondentieThreadIdRouteImport
      parentRoute: typeof BeheerContractenContractIdRouteRoute
    }
  }
}

interface OrganisatieProfielRouteRouteChildren {
  OrganisatieProfielIndexRoute: typeof OrganisatieProfielIndexRoute
  OrganisatieProfielMedewerkersAanmakenRoute: typeof OrganisatieProfielMedewerkersAanmakenRoute
  OrganisatieProfielGegevensIndexRoute: typeof OrganisatieProfielGegevensIndexRoute
  OrganisatieProfielMedewerkersIndexRoute: typeof OrganisatieProfielMedewerkersIndexRoute
}

const OrganisatieProfielRouteRouteChildren: OrganisatieProfielRouteRouteChildren =
  {
    OrganisatieProfielIndexRoute: OrganisatieProfielIndexRoute,
    OrganisatieProfielMedewerkersAanmakenRoute:
      OrganisatieProfielMedewerkersAanmakenRoute,
    OrganisatieProfielGegevensIndexRoute: OrganisatieProfielGegevensIndexRoute,
    OrganisatieProfielMedewerkersIndexRoute:
      OrganisatieProfielMedewerkersIndexRoute,
  }

const OrganisatieProfielRouteRouteWithChildren =
  OrganisatieProfielRouteRoute._addFileChildren(
    OrganisatieProfielRouteRouteChildren,
  )

interface ProfielRouteRouteChildren {
  ProfielGegevensIndexRoute: typeof ProfielGegevensIndexRoute
  ProfielGekoppeldeCursistenIndexRoute: typeof ProfielGekoppeldeCursistenIndexRoute
}

const ProfielRouteRouteChildren: ProfielRouteRouteChildren = {
  ProfielGegevensIndexRoute: ProfielGegevensIndexRoute,
  ProfielGekoppeldeCursistenIndexRoute: ProfielGekoppeldeCursistenIndexRoute,
}

const ProfielRouteRouteWithChildren = ProfielRouteRoute._addFileChildren(
  ProfielRouteRouteChildren,
)

interface BeheerContractenContractIdRouteRouteChildren {
  BeheerContractenContractIdIndexRoute: typeof BeheerContractenContractIdIndexRoute
  BeheerContractenContractIdCorrespondentieThreadIdRoute: typeof BeheerContractenContractIdCorrespondentieThreadIdRoute
  BeheerContractenContractIdOrganisatiesOrganizationRoute: typeof BeheerContractenContractIdOrganisatiesOrganizationRoute
  BeheerContractenContractIdCorrespondentieIndexRoute: typeof BeheerContractenContractIdCorrespondentieIndexRoute
}

const BeheerContractenContractIdRouteRouteChildren: BeheerContractenContractIdRouteRouteChildren =
  {
    BeheerContractenContractIdIndexRoute: BeheerContractenContractIdIndexRoute,
    BeheerContractenContractIdCorrespondentieThreadIdRoute:
      BeheerContractenContractIdCorrespondentieThreadIdRoute,
    BeheerContractenContractIdOrganisatiesOrganizationRoute:
      BeheerContractenContractIdOrganisatiesOrganizationRoute,
    BeheerContractenContractIdCorrespondentieIndexRoute:
      BeheerContractenContractIdCorrespondentieIndexRoute,
  }

const BeheerContractenContractIdRouteRouteWithChildren =
  BeheerContractenContractIdRouteRoute._addFileChildren(
    BeheerContractenContractIdRouteRouteChildren,
  )

interface BeheerCursistenStudentIdRouteRouteChildren {
  BeheerCursistenStudentIdCorrespondentieThreadIdRoute: typeof BeheerCursistenStudentIdCorrespondentieThreadIdRoute
  BeheerCursistenStudentIdCorrespondentieIndexRoute: typeof BeheerCursistenStudentIdCorrespondentieIndexRoute
  BeheerCursistenStudentIdGegevensIndexRoute: typeof BeheerCursistenStudentIdGegevensIndexRoute
  BeheerCursistenStudentIdIntakeIndexRoute: typeof BeheerCursistenStudentIdIntakeIndexRoute
  BeheerCursistenStudentIdLessenIndexRoute: typeof BeheerCursistenStudentIdLessenIndexRoute
  BeheerCursistenStudentIdRapportagesIndexRoute: typeof BeheerCursistenStudentIdRapportagesIndexRoute
  BeheerCursistenStudentIdTweedeAanspreekpuntIndexRoute: typeof BeheerCursistenStudentIdTweedeAanspreekpuntIndexRoute
  BeheerCursistenStudentIdVoortgangIndexRoute: typeof BeheerCursistenStudentIdVoortgangIndexRoute
}

const BeheerCursistenStudentIdRouteRouteChildren: BeheerCursistenStudentIdRouteRouteChildren =
  {
    BeheerCursistenStudentIdCorrespondentieThreadIdRoute:
      BeheerCursistenStudentIdCorrespondentieThreadIdRoute,
    BeheerCursistenStudentIdCorrespondentieIndexRoute:
      BeheerCursistenStudentIdCorrespondentieIndexRoute,
    BeheerCursistenStudentIdGegevensIndexRoute:
      BeheerCursistenStudentIdGegevensIndexRoute,
    BeheerCursistenStudentIdIntakeIndexRoute:
      BeheerCursistenStudentIdIntakeIndexRoute,
    BeheerCursistenStudentIdLessenIndexRoute:
      BeheerCursistenStudentIdLessenIndexRoute,
    BeheerCursistenStudentIdRapportagesIndexRoute:
      BeheerCursistenStudentIdRapportagesIndexRoute,
    BeheerCursistenStudentIdTweedeAanspreekpuntIndexRoute:
      BeheerCursistenStudentIdTweedeAanspreekpuntIndexRoute,
    BeheerCursistenStudentIdVoortgangIndexRoute:
      BeheerCursistenStudentIdVoortgangIndexRoute,
  }

const BeheerCursistenStudentIdRouteRouteWithChildren =
  BeheerCursistenStudentIdRouteRoute._addFileChildren(
    BeheerCursistenStudentIdRouteRouteChildren,
  )

interface BeheerGroepenGroupIdRouteRouteChildren {
  BeheerGroepenGroupIdCorrespondentieThreadIdRoute: typeof BeheerGroepenGroupIdCorrespondentieThreadIdRoute
  BeheerGroepenGroupIdCorrespondentieIndexRoute: typeof BeheerGroepenGroupIdCorrespondentieIndexRoute
  BeheerGroepenGroupIdLessenIndexRoute: typeof BeheerGroepenGroupIdLessenIndexRoute
  BeheerGroepenGroupIdStudentsIndexRoute: typeof BeheerGroepenGroupIdStudentsIndexRoute
}

const BeheerGroepenGroupIdRouteRouteChildren: BeheerGroepenGroupIdRouteRouteChildren =
  {
    BeheerGroepenGroupIdCorrespondentieThreadIdRoute:
      BeheerGroepenGroupIdCorrespondentieThreadIdRoute,
    BeheerGroepenGroupIdCorrespondentieIndexRoute:
      BeheerGroepenGroupIdCorrespondentieIndexRoute,
    BeheerGroepenGroupIdLessenIndexRoute: BeheerGroepenGroupIdLessenIndexRoute,
    BeheerGroepenGroupIdStudentsIndexRoute:
      BeheerGroepenGroupIdStudentsIndexRoute,
  }

const BeheerGroepenGroupIdRouteRouteWithChildren =
  BeheerGroepenGroupIdRouteRoute._addFileChildren(
    BeheerGroepenGroupIdRouteRouteChildren,
  )

interface BeheerMedewerkersOrganizationUserIdRouteRouteChildren {
  BeheerMedewerkersOrganizationUserIdGegevensIndexRoute: typeof BeheerMedewerkersOrganizationUserIdGegevensIndexRoute
  BeheerMedewerkersOrganizationUserIdGekoppeldeCursistenIndexRoute: typeof BeheerMedewerkersOrganizationUserIdGekoppeldeCursistenIndexRoute
}

const BeheerMedewerkersOrganizationUserIdRouteRouteChildren: BeheerMedewerkersOrganizationUserIdRouteRouteChildren =
  {
    BeheerMedewerkersOrganizationUserIdGegevensIndexRoute:
      BeheerMedewerkersOrganizationUserIdGegevensIndexRoute,
    BeheerMedewerkersOrganizationUserIdGekoppeldeCursistenIndexRoute:
      BeheerMedewerkersOrganizationUserIdGekoppeldeCursistenIndexRoute,
  }

const BeheerMedewerkersOrganizationUserIdRouteRouteWithChildren =
  BeheerMedewerkersOrganizationUserIdRouteRoute._addFileChildren(
    BeheerMedewerkersOrganizationUserIdRouteRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  OrganisatieProfielRouteRoute: OrganisatieProfielRouteRouteWithChildren,
  ProfielRouteRoute: ProfielRouteRouteWithChildren,
  CorrespondentieThreadIdRoute: CorrespondentieThreadIdRoute,
  LoginTokenRoute: LoginTokenRoute,
  LoginGoogle_ssoRoute: LoginGoogle_ssoRoute,
  LoginMicrosoft_ssoRoute: LoginMicrosoft_ssoRoute,
  BeheerIndexRoute: BeheerIndexRoute,
  CorrespondentieIndexRoute: CorrespondentieIndexRoute,
  DashboardIndexRoute: DashboardIndexRoute,
  LoginIndexRoute: LoginIndexRoute,
  BeheerContractenContractIdRouteRoute:
    BeheerContractenContractIdRouteRouteWithChildren,
  BeheerCursistenStudentIdRouteRoute:
    BeheerCursistenStudentIdRouteRouteWithChildren,
  BeheerGroepenGroupIdRouteRoute: BeheerGroepenGroupIdRouteRouteWithChildren,
  BeheerMedewerkersOrganizationUserIdRouteRoute:
    BeheerMedewerkersOrganizationUserIdRouteRouteWithChildren,
  BeheerCursistenAanmakenRoute: BeheerCursistenAanmakenRoute,
  BeheerMedewerkersAanmakenRoute: BeheerMedewerkersAanmakenRoute,
  AuthFailed_ssoIndexRoute: AuthFailed_ssoIndexRoute,
  AuthSso_callbackIndexRoute: AuthSso_callbackIndexRoute,
  BeheerAanmeldingenIndexRoute: BeheerAanmeldingenIndexRoute,
  BeheerContractenIndexRoute: BeheerContractenIndexRoute,
  BeheerCursistenIndexRoute: BeheerCursistenIndexRoute,
  BeheerGebruikersIndexRoute: BeheerGebruikersIndexRoute,
  BeheerGroepenIndexRoute: BeheerGroepenIndexRoute,
  BeheerMedewerkersIndexRoute: BeheerMedewerkersIndexRoute,
  BeheerAanmeldingenStudentRegistrationIdOpnieuwIndienenRoute:
    BeheerAanmeldingenStudentRegistrationIdOpnieuwIndienenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
